import { getNotificacoes, marcarComoLida } from "@spark/services/notificacoes";
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { notificacaoColumns as buildColumns } from '../../components/tanStackColumns';

const useNotificacoesListagem = () => {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterLoading, setFilterLoading] = useState(false);
  const [filters, setFilters] = useState({});
  const [paginationState, setPaginationState] = useState({
    pageIndex: 0,
    pageSize: 10
  });
  const [totalRegistros, setTotalRegistros] = useState(0);
  const load = useCallback(async (f = filters, p = paginationState) => {
    try {
      setLoading(true);
      const serviceFilters = { ...(f.search && {
          search: f.search
        }),
        ...(f.lida !== undefined && f.lida !== '' && {
          Lida: f.lida
        }),
        ...(f.numeroCarga && {
          numeroCarga: f.numeroCarga
        }),
        ...(f.numeroNota && {
          numeroNota: f.numeroNota
        }),
        pagina: p.pageIndex + 1,
        quantidadePorPagina: p.pageSize
      };
      const response = await getNotificacoes(serviceFilters);
      const lista = response?.registros || [];
      setData(lista);
      setTotalRegistros(response?.totalRegistros || lista.length || 0);
    } finally {
      setLoading(false);
    }
  }, [filters, paginationState]);
  useEffect(() => {
    load();
  }, [load]);
  const handleFilterApply = useCallback(newFilters => {
    setFilterLoading(true);
    setFilters(newFilters);
    setPaginationState(prev => ({ ...prev,
      pageIndex: 0
    })); // pós-setState load na próxima renderização via effect

    setTimeout(() => setFilterLoading(false), 0);
  }, []);
  const handleLimparFiltros = useCallback(() => {
    handleFilterApply({});
  }, [handleFilterApply]);
  const handlePaginationChange = useCallback(updater => {
    if (typeof updater === 'number') {
      setPaginationState(prev => ({ ...prev,
        pageIndex: updater
      }));
      return;
    }

    if (typeof updater === 'function') {
      setPaginationState(prev => updater(prev));
      return;
    }

    if (updater && typeof updater === 'object') {
      setPaginationState(updater);
      return;
    }
  }, []);
  const handleRowClick = useCallback(row => {
    if (!row || !row.original) return;

    const n = row.original;

    if (n.AcompanhamentoId) {
      history.push(`/pages/acompanhamentos/detalhes/${n.AcompanhamentoId}`);
    }
  }, [history]);
  const onMarcarLida = useCallback(async registro => {
    try {
      await marcarComoLida(registro.Id);
      await load();
    } catch (_) {}
  }, [load]);
  const onVisualizar = useCallback(registro => {
    if (registro.AcompanhamentoId) {
      history.push(`/pages/acompanhamentos/detalhes/${registro.AcompanhamentoId}`);
    }
  }, [history]);
  const columns = useMemo(() => buildColumns(r => onMarcarLida(r), r => onVisualizar(r)), [onMarcarLida, onVisualizar]);
  return {
    data,
    loading,
    filterLoading,
    totalRegistros,
    paginationState,
    handleFilterApply,
    handleLimparFiltros,
    handlePaginationChange,
    handleRowClick,
    columns
  };
};

export default useNotificacoesListagem;
